module.exports = __webpack_public_path__ + "static/img/s50.f0c5551d.png";